export const DISHES = [
  {
    path: "/images/plats/MACHISO_HERO_01.jpg",
    label: "Photos des plats →",
  },
  {
    path: "/images/plats/MACHISO_BAEK_BAN.jpg",
    label: "Baek Ban",
  },
  {
    path: "/images/plats/MACHISO_TIRAMISU_MATCHA.jpg",
    label: "Tiramisu Matcha",
  },
  {
    path: "/images/plats/MACHISO_TTEOKBOKKI.jpg",
    label: "Tteokbokki",
  },
  {
    path: "/images/plats/MACHISO_KOREAN_FRIED_CHICKEN.jpg",
    label: "Korean Fried Chicken",
  },
  {
    path: "/images/plats/MACHISO_KIMCHI_JIGGAE.jpg",
    label: "Kimchi Jiggae",
  },
  {
    path: "/images/plats/MACHISO_JAPCHAE.jpg",
    label: "Japchae",
  },
  {
    path: "/images/plats/MACHISO_KUN_MANDU.jpg",
    label: "Kun Mandu",
  },
  {
    path: "/images/plats/MACHISO_UDON.jpg",
    label: "Udon",
  },
  {
    path: "/images/plats/MACHISO_WAKAME.jpg",
    label: "Wakame",
  },
  {
    path: "/images/plats/MACHISO_MOCHIS_GLACES.jpg",
    label: "Mochis Glaces",
  },
  {
    path: "/images/plats/MACHISO_PANNA_COTTA.jpg",
    label: "Panna Cotta",
  },
  {
    path: "/images/plats/MACHISO_BIBIMBAP.jpg",
    label: "Bibimbap",
  },
  {
    path: "/images/plats/MACHISO_KIMBAP.jpg",
    label: "Kimbap",
  },
  {
    path: "/images/plats/MACHISO_TEMPURA.jpg",
    label: "Tempura",
  },
  {
    path: "/images/plats/MACHISO_JEON.jpg",
    label: "Jeon",
  },
];



// WEBPACK FOOTER //
// ./src/components/DishImageGallery/DishImageGallery.helpers.js